import { FitlineClubMemberBadgeDescription, Badge } from 'components/badges';
import { FitlineFIcon } from 'libs/icons/svg-icons/svgs/fitline-f';

interface IFitlineClubMemberBadgeProps {
  readonly hideDetails?: boolean;
}

export function FitlineClubMemberBadge(props: IFitlineClubMemberBadgeProps) {
  return (
    <Badge
      title="FC"
      hideDetails={props.hideDetails}
      icon={<FitlineFIcon size={12} className="text-[#cd0039]" />}
      backgroundColorClass="#fff2e3"
      textColorClass="#cd0039"
      tooltipDetailsContent={<FitlineClubMemberBadgeDescription />}
    />
  );
}
